import React, { useState } from 'react';
import { HeroSection } from '../../components/HeroSection';
import { Button } from '../../components/ui/Button';
import { ChevronDown, ChevronUp, FileText, Image, Mic, DollarSign } from 'lucide-react';
export function Contribute() {
  const [expandedSection, setExpandedSection] = useState<number | null>(0);
  const guidelines = [{
    icon: <FileText className="h-8 w-8" data-id="element-785" />,
    title: "What We're Looking For",
    content: <div className="space-y-4" data-id="element-786">
          <p className="text-gray-700" data-id="element-787">
            We publish essays, reporting, poetry, visual art, and hybrid forms
            that center fat liberation and justice.
          </p>
          <div className="bg-brand-orange/5 p-4 border-l-4 border-brand-orange" data-id="element-788">
            <h4 className="font-bold mb-2" data-id="element-789">We want work that:</h4>
            <ul className="space-y-2 text-sm" data-id="element-790">
              <li className="flex items-start" data-id="element-791">
                <span className="text-brand-orange mr-2" data-id="element-792">✓</span>
                <span data-id="element-793">Challenges dominant narratives about fat bodies</span>
              </li>
              <li className="flex items-start" data-id="element-794">
                <span className="text-brand-orange mr-2" data-id="element-795">✓</span>
                <span data-id="element-796">Centers fat people's lived experiences</span>
              </li>
              <li className="flex items-start" data-id="element-797">
                <span className="text-brand-orange mr-2" data-id="element-798">✓</span>
                <span data-id="element-799">Engages with theory, history, or political analysis</span>
              </li>
              <li className="flex items-start" data-id="element-800">
                <span className="text-brand-orange mr-2" data-id="element-801">✓</span>
                <span data-id="element-802">Takes risks formally or conceptually</span>
              </li>
              <li className="flex items-start" data-id="element-803">
                <span className="text-brand-orange mr-2" data-id="element-804">✓</span>
                <span data-id="element-805">Shows craft and attention to language</span>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-4 border-l-4 border-gray-300" data-id="element-806">
            <h4 className="font-bold mb-2" data-id="element-807">We're not looking for:</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-808">
              <li className="flex items-start" data-id="element-809">
                <span className="mr-2" data-id="element-810">✗</span>
                <span data-id="element-811">101-level explainers for thin audiences</span>
              </li>
              <li className="flex items-start" data-id="element-812">
                <span className="mr-2" data-id="element-813">✗</span>
                <span data-id="element-814">"Body positivity" or self-love narratives</span>
              </li>
              <li className="flex items-start" data-id="element-815">
                <span className="mr-2" data-id="element-816">✗</span>
                <span data-id="element-817">Work by thin people about their "body image"</span>
              </li>
              <li className="flex items-start" data-id="element-818">
                <span className="mr-2" data-id="element-819">✗</span>
                <span data-id="element-820">Anything that centers weight loss or diet culture</span>
              </li>
            </ul>
          </div>
        </div>
  }, {
    icon: <Image className="h-8 w-8" data-id="element-821" />,
    title: 'Submission Guidelines',
    content: <div className="space-y-4" data-id="element-822">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-823">
            <div data-id="element-824">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-825">
                Essays & Reporting
              </h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-826">
                <li data-id="element-827">
                  <strong data-id="element-828">Length:</strong> 1,500-5,000 words
                </li>
                <li data-id="element-829">
                  <strong data-id="element-830">Format:</strong> .doc or .docx
                </li>
                <li data-id="element-831">
                  <strong data-id="element-832">Include:</strong> Brief bio (50-100 words)
                </li>
                <li data-id="element-833">
                  <strong data-id="element-834">Response time:</strong> 4-6 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-835">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-836">Poetry</h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-837">
                <li data-id="element-838">
                  <strong data-id="element-839">Length:</strong> Up to 5 poems
                </li>
                <li data-id="element-840">
                  <strong data-id="element-841">Format:</strong> .doc or .docx
                </li>
                <li data-id="element-842">
                  <strong data-id="element-843">Include:</strong> Brief bio (50-100 words)
                </li>
                <li data-id="element-844">
                  <strong data-id="element-845">Response time:</strong> 6-8 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-846">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-847">Visual Work</h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-848">
                <li data-id="element-849">
                  <strong data-id="element-850">Format:</strong> High-res JPG or PNG
                </li>
                <li data-id="element-851">
                  <strong data-id="element-852">Include:</strong> Artist statement (200-300 words)
                </li>
                <li data-id="element-853">
                  <strong data-id="element-854">Series:</strong> 5-10 images preferred
                </li>
                <li data-id="element-855">
                  <strong data-id="element-856">Response time:</strong> 4-6 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-857">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-858">
                Hybrid/Experimental
              </h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-859">
                <li data-id="element-860">
                  <strong data-id="element-861">Format:</strong> Varies—contact us first
                </li>
                <li data-id="element-862">
                  <strong data-id="element-863">Include:</strong> Description of form/concept
                </li>
                <li data-id="element-864">
                  <strong data-id="element-865">Examples:</strong> Comics, audio, video essays
                </li>
                <li data-id="element-866">
                  <strong data-id="element-867">Response time:</strong> 6-8 weeks
                </li>
              </ul>
            </div>
          </div>
        </div>
  }, {
    icon: <DollarSign className="h-8 w-8" data-id="element-868" />,
    title: 'Payment & Rights',
    content: <div className="space-y-4" data-id="element-869">
          <div className="bg-brand-orange/10 p-6 border-2 border-brand-orange" data-id="element-870">
            <h4 className="font-bold text-lg mb-3" data-id="element-871">We Pay Our Contributors</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" data-id="element-872">
              <div data-id="element-873">
                <p className="font-bold text-brand-orange mb-1" data-id="element-874">
                  Essays & Reporting
                </p>
                <p data-id="element-875">$0.25/word (minimum $375)</p>
              </div>
              <div data-id="element-876">
                <p className="font-bold text-brand-orange mb-1" data-id="element-877">Poetry</p>
                <p data-id="element-878">$100 per poem</p>
              </div>
              <div data-id="element-879">
                <p className="font-bold text-brand-orange mb-1" data-id="element-880">Visual Work</p>
                <p data-id="element-881">$200-500 depending on scope</p>
              </div>
              <div data-id="element-882">
                <p className="font-bold text-brand-orange mb-1" data-id="element-883">Hybrid Forms</p>
                <p data-id="element-884">Negotiated based on project</p>
              </div>
            </div>
          </div>
          <div className="prose prose-sm" data-id="element-885">
            <h4 className="font-bold" data-id="element-886">Rights & Licensing</h4>
            <p className="text-gray-700" data-id="element-887">
              We purchase first serial rights. You retain copyright and can
              republish your work elsewhere after 90 days. We ask that you
              credit ReGrowth as the original publisher.
            </p>
            <h4 className="font-bold mt-4" data-id="element-888">Payment Timeline</h4>
            <p className="text-gray-700" data-id="element-889">
              Payment is issued within 30 days of publication via PayPal, Venmo,
              or check. International contributors: we can accommodate various
              payment methods.
            </p>
          </div>
        </div>
  }, {
    icon: <Mic className="h-8 w-8" data-id="element-890" />,
    title: 'Editorial Process',
    content: <div className="space-y-4" data-id="element-891">
          <p className="text-gray-700" data-id="element-892">
            We believe in collaborative editing. If we accept your piece, here's
            what to expect:
          </p>
          <div className="space-y-6" data-id="element-893">
            <div className="flex gap-4" data-id="element-894">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-895">
                1
              </div>
              <div data-id="element-896">
                <h4 className="font-bold mb-1" data-id="element-897">Acceptance & Contract</h4>
                <p className="text-sm text-gray-700" data-id="element-898">
                  We'll send you a contract outlining payment, timeline, and
                  rights. Sign and return within 2 weeks.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-899">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-900">
                2
              </div>
              <div data-id="element-901">
                <h4 className="font-bold mb-1" data-id="element-902">Developmental Edit</h4>
                <p className="text-sm text-gray-700" data-id="element-903">
                  Your editor will send big-picture feedback on structure,
                  argument, and development. You'll have 2-3 weeks to revise.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-904">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-905">
                3
              </div>
              <div data-id="element-906">
                <h4 className="font-bold mb-1" data-id="element-907">Line Edit</h4>
                <p className="text-sm text-gray-700" data-id="element-908">
                  We'll work on language, clarity, and flow. This is a
                  collaborative process—we'll discuss changes with you.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-909">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-910">
                4
              </div>
              <div data-id="element-911">
                <h4 className="font-bold mb-1" data-id="element-912">Copyedit & Fact-Check</h4>
                <p className="text-sm text-gray-700" data-id="element-913">
                  Our copyeditor will check grammar, style, and facts. You'll
                  review and approve final changes.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-914">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-915">
                5
              </div>
              <div data-id="element-916">
                <h4 className="font-bold mb-1" data-id="element-917">Publication</h4>
                <p className="text-sm text-gray-700" data-id="element-918">
                  We'll schedule your piece and promote it across our channels.
                  You'll receive payment within 30 days.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-4 border-l-4 border-brand-orange mt-6" data-id="element-919">
            <p className="text-sm text-gray-700" data-id="element-920">
              <strong data-id="element-921">Timeline:</strong> From acceptance to publication
              typically takes 2-4 months, depending on the piece and our
              editorial calendar.
            </p>
          </div>
        </div>
  }];
  return <div className="min-h-screen bg-brand-cream" data-id="element-922">
      <HeroSection title="Contribute / Write With Us" subtitle="We're always looking for fat writers, artists, and thinkers to join our pages." tag="The Digital Publication" bgColor="orange" data-id="element-923" />

      {/* Introduction */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-924">
        <div className="prose prose-lg" data-id="element-925">
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-926">
            The Digital Publication exists because of{' '}
            <strong className="text-brand-orange" data-id="element-927">
              fat people's creativity, intellect, and courage
            </strong>
            . We want to publish your work—whether you're an established writer
            or this is your first time submitting.
          </p>
          <p className="text-lg text-gray-600 mt-4" data-id="element-928">
            We especially encourage submissions from fat Black, Indigenous,
            disabled, trans, and working-class writers.
          </p>
        </div>
      </section>

      {/* Accordion Guidelines */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-929">
        <div className="space-y-4" data-id="element-930">
          {guidelines.map((section, index) => <div key={index} className="border-2 border-brand-black bg-white" data-id="element-931">
              <button onClick={() => setExpandedSection(expandedSection === index ? null : index)} className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-932">
                <div className="flex items-center gap-4" data-id="element-933">
                  <div className="text-brand-orange" data-id="element-934">{section.icon}</div>
                  <h3 className="text-xl font-black uppercase text-brand-black text-left" data-id="element-935">
                    {section.title}
                  </h3>
                </div>
                {expandedSection === index ? <ChevronUp className="h-6 w-6 text-brand-orange flex-shrink-0" data-id="element-936" /> : <ChevronDown className="h-6 w-6 text-gray-400 flex-shrink-0" data-id="element-937" />}
              </button>

              {expandedSection === index && <div className="p-6 pt-0 border-t-2 border-gray-100" data-id="element-938">
                  {section.content}
                </div>}
            </div>)}
        </div>
      </section>

      {/* Submit CTA */}
      <section className="py-20 bg-brand-orange text-white" data-id="element-939">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-940">
          <h2 className="text-3xl font-black uppercase mb-6" data-id="element-941">
            Ready to Submit?
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-942">
            Send your work to submissions@regrowth.com with "SUBMISSION: [Type]"
            in the subject line.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-943">
            <Button color="white" size="lg" data-id="element-944">
              Email Your Submission
            </Button>
            <Button variant="outline" color="white" size="lg" data-id="element-945">
              Questions? Contact Us
            </Button>
          </div>
          <p className="text-sm mt-8 opacity-75" data-id="element-946">
            We read submissions year-round. No simultaneous submissions please.
          </p>
        </div>
      </section>
    </div>;
}